import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import axios from "axios";

import { API, BACKEND_URL } from "@/lib/api";


export default function AppFooter() {
  const currentYear = new Date().getFullYear();
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get(`${API}/branding/logo`);
        if (response.data && typeof response.data === 'object' && response.data.logo_url) {
          setLogoUrl(`${BACKEND_URL || ""}${response.data.logo_url}`);
        }
      } catch (error) {
        console.error("Failed to fetch logo in footer:", error);
      }
    };
    fetchLogo();
  }, []);

  return (
    <footer className="bg-card border-t mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info with Logo - VERGRÖSSERT */}
          <div className="space-y-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt="mokiplaner"
                  className="h-14 md:h-16 w-auto object-contain"
                  style={{ transform: 'scale(var(--logo-scale, 1))' }}
                />
              ) : (
                <img
                  src="/assets/moki-logo.svg"
                  alt="MOKI PLANER"
                  className="h-14 md:h-16 w-auto object-contain"
                  style={{ transform: 'scale(var(--logo-scale, 1))' }}
                />
              )}
            </Link>
            <p className="text-sm text-muted-foreground">
              Der perfekte Moment – digital geplant.
            </p>
          </div>

          {/* Legal */}
          <div className="space-y-3">
            <h4 className="font-semibold">Rechtliches</h4>
            <nav className="flex flex-col space-y-2 text-sm">
              <Link to="/impressum" className="text-muted-foreground hover:text-primary transition-colors">
                Impressum
              </Link>
              <Link to="/datenschutz" className="text-muted-foreground hover:text-primary transition-colors">
                Datenschutz
              </Link>
              <Link to="/agb" className="text-muted-foreground hover:text-primary transition-colors">
                AGB
              </Link>
            </nav>
          </div>

          {/* Support */}
          <div className="space-y-3">
            <h4 className="font-semibold">Support</h4>
            <nav className="flex flex-col space-y-2 text-sm">
              <Link to="/kontakt" className="text-muted-foreground hover:text-primary transition-colors">
                Kontakt
              </Link>
              <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">
                FAQ
              </Link>
              <a
                href="mailto:info@mokiplaner.com"
                className="text-muted-foreground hover:text-primary transition-colors"
              >
                info@mokiplaner.com
              </a>
            </nav>
          </div>

          {/* Product */}
          <div className="space-y-3">
            <h4 className="font-semibold">Produkt</h4>
            <nav className="flex flex-col space-y-2 text-sm">
              <Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors">
                Preise
              </Link>
              <Link to="/features" className="text-muted-foreground hover:text-primary transition-colors">
                Features
              </Link>
              <Link to="/dashboard" className="text-muted-foreground hover:text-primary transition-colors">
                Dashboard
              </Link>
            </nav>
          </div>
        </div>

        <div className="h-px bg-border my-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>
            © {currentYear} mokiplaner.com. Alle Rechte vorbehalten.
          </p>
          <p className="flex items-center gap-2">
            Made with <Heart className="w-4 h-4 text-red-500 fill-current" /> in Deutschland
          </p>
        </div>
      </div>
    </footer>
  );
}
